import { getStoryblokProductList } from './../api/plp-search.api';
export const gotStoryblokProductListEvent = getStoryblokProductList.matchFulfilled;
